import { ol_extent, ol_geom } from "@omnia/exports/openlayers"
import IMapTopologyService = omnia.map.IMapTopologyService

export function getBestFitAngle(geometry: ol_geom.Geometry, topo: IMapTopologyService) {

    if (!(geometry instanceof ol_geom.Polygon)) {
        return null
    }

    let minArea = Number.MAX_VALUE
    let minAreaAngle = null

    const temp = topo.getGeometry(geometry)

    const centroid = topo.getCentroid(temp)
    const convexHull = topo.getConvexHull(temp).getOpenLayersGeometry()

    const outerRing = geometry.getLinearRing(0).getCoordinates()

    for (let i = 1; i < (outerRing.length - 1); i++) {

        const p1 = outerRing[i - 1]
        const p2 = outerRing[i]

        const angle = Math.atan2(p2[1] - p1[1], p2[0] - p1[0])

        const rotatedHull = (convexHull as any).clone()
        rotatedHull.rotate(-angle, centroid)

        const extent = rotatedHull.getExtent()
        const size = ol_extent.getSize(extent)
        const area = size[0] * size[1]

        if (area < minArea) {
            minArea = area
            minAreaAngle = angle
        }

    }

    return minAreaAngle >= 0
        ? minAreaAngle
        : minAreaAngle + (2 * Math.PI)

}
